import React, { useState } from "react";
import DefaultQr from "../assets/team_img/new_ad.jpg";
import LogoImage from "../assets/logo.png";
import "../styles/Register.css";

const App = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [teamSize, setTeamSize] = useState("");
  const [themeCategory, setThemeCategory] = useState("");
  const [teamMembers, setTeamMembers] = useState([]);
  const [entryFee, setEntryFee] = useState(0);
  const [qrCode, setQrCode] = useState(DefaultQr); // Dynamic QR Code
  const [loading, setLoading] = useState(false);


  const handleTeamSizeChange = (e) => {
    const size = parseInt(e.target.value, 10);
    setTeamSize(size);
    setQrCode(DefaultQr); // Update QR Code
    setTeamMembers(Array.from({ length: size - 1 }, () => ({ name: "", phone: "" })));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData(event.target);

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbzjHtQDOhF8HuAJWiu7Egfp-pnpMlvRsgFLXU4LeXfvHrCrNvTa0Jp_5arQnTY3j9jR/exec",
        { method: "POST", body: formData }
      );

      const data = await response.text();
      if (data.trim() === "Success") {
        setPopupVisible(true);
        setTimeout(() => {
          setPopupVisible(false);
          event.target.reset();
          setTeamSize("");
          setTeamMembers([]);
          setEntryFee(0);
          setQrCode(DefaultQr);
          window.location.href = "/";
        }, 4000);
      } else {
        alert("There was a problem with the submission. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please check your internet connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="register">
      <div className="main-background1">
        <source className="main_bg_cont1" />
      </div>

      <div className="register-form">
        <h2>Registrations are Closed!!</h2>

        <div className="hackathon-details">
          <p><strong>Date:</strong> 28<sup>th</sup> Feb - 1<sup>st</sup> March, 2025</p>
          <p><strong>Duration:</strong> 24 Hours (Overnight Hackathon)</p>
          <p><strong>Eligibility:</strong> Open to all Engineering UG students (Individual & Team Participation Allowed)</p>
          <p><strong>Venue:</strong> Arya College of Engineering (Arya Main Campus), Jaipur</p>
          <p><strong>Team Size:</strong> 2-4 Members</p>
          <p><strong>Perks:</strong> Certificates, Goodies, Networking & so on.</p>
          <br />
          <p><strong>If you have any doubt just contact our Support Team</strong></p>

          <a className="support_button1" href="/support">Support team</a>
        </div>

      </div>
    </section>
  );
};

export default App;